<template>
  <v-container class="mt-4 ml-2 documentos-oficiales-view" fluid>
    <v-row class="mb-2">
      <v-col cols="12" md="4">
        <v-card class="kpi-card kpi-card--principal" flat>
          <div class="kpi-title">Total de documentos</div>
          <div class="kpi-value">{{ totalProcesos }}</div>
          <div class="kpi-caption">Documentos oficiales registrados</div>
        </v-card>
      </v-col>
      <v-col cols="12" md="8">
        <v-card class="kpi-card" flat>
          <div class="kpi-title mb-3">Procesos por departamento</div>
          <div class="kpi-grid">
            <div class="kpi-item" v-for="item in kpiProcesosPorDepartamento" :key="item.departamento">
              <span class="kpi-item-label">{{ item.departamento }}</span>
              <v-chip x-small color="primary" dark>{{ item.total }}</v-chip>
            </div>
            <span v-if="!kpiProcesosPorDepartamento.length" class="kpi-empty">
              Sin procesos para mostrar
            </span>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard card-minimal">
          <v-card-title primary-title class="pb-2">
            <div>
              <span class="text-subtitle-1 font-weight-medium">Documentos Oficiales</span>
              <div class="text-caption grey--text text--darken-1">Vista general y control documental</div>
            </div>
            <v-spacer></v-spacer>

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar..."
              single-line
              hide-details
              dense
              outlined
              class="mr-3 minimal-input"
              style="max-width: 220px;"
            />

            <v-select
              v-model="departamentoFiltro"
              :items="departamentos"
              item-text="departamento"
              item-value="id"
              label="Departamento"
              hide-details
              dense
              clearable
              outlined
              class="mr-3 minimal-input"
              style="max-width: 220px;"
            />

            <v-btn
              v-if="canManageDocs"
              color="primary"
              dark
              class="text-capitalize mr-2"
              @click="crearDocumento()"
              small
              depressed
            >
              <v-icon left small>mdi-plus</v-icon>
              Subir Documento
            </v-btn>

            <v-btn color="primary" dark class="text-capitalize" @click="initializeDocumentos()" small outlined>
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-data-table
              :headers="headersDocumentos"
              :items="documentosFiltrados"
              :search="search"
              class="elevation-0 table-minimal"
              :mobile-breakpoint="100"
              dense
            >
              <template v-slot:item.archivo_nombre="{ item }">
                <div class="d-flex align-center">
                  <v-btn v-if="item.archivo_nombre" icon small color="primary" @click="previsualizarDocumento(item)">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                  <v-btn v-if="item.archivo_nombre && canDownloadDocs" icon small color="primary" @click="descargarDocumento(item)">
                    <v-icon>mdi-file-download</v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-slot:item.acciones="{ item }">
                <v-row v-if="canManageDocs" class="ma-0">
                  <v-btn small icon @click="abrirDialogDocumento(item)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn small color="red" dark icon @click="eliminarDocumento(item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-row>
                <span v-else class="grey--text text--darken-1">Solo lectura</span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogDocumento" max-width="600px" persistent>
      <v-card class="shadowCard">
        <v-card-title primary-title>
          <span class="text-subtitle-1">{{ formDoc.id ? "Editar" : "Nuevo" }} Documento Oficial</span>
        </v-card-title>
        <v-card-text>
          <v-alert type="info" text border="left" class="mb-4" dense outlined>
            <div class="text-caption">
              <b>Importante:</b> una vez subido el documento, solo usuarios autorizados por iderp pueden editarlo o eliminarlo.
            </div>
          </v-alert>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formDoc.folio"
                label="Folio de documento"
                filled
                dense
                disabled
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formDoc.nombre_documento"
                label="Nombre del documento"
                filled
                dense
                :disabled="!canManageDocs"
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="formDoc.id_departamento"
                :items="departamentos"
                item-text="departamento"
                item-value="id"
                label="Seleccionar departamento"
                filled
                dense
                clearable
                :disabled="!canManageDocs"
              />
            </v-col>
            <v-col cols="12">
              <v-file-input
                v-model="archivoDoc"
                label="Subir archivo (PDF, DOC, DOCX)"
                accept=".pdf,.doc,.docx"
                filled
                dense
                prepend-icon="mdi-file-document"
                :disabled="!canManageDocs || !!formDoc.id"
              />
              <div v-if="formDoc.archivo_nombre" class="text-caption blue--text">
                Archivo actual: {{ formDoc.archivo_nombre }}
              </div>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="formDoc.comentarios"
                label="Comentarios"
                filled
                dense
                rows="3"
                auto-grow
                :disabled="!canManageDocs"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="formDoc.estatus"
                :items="['Pendiente', 'Aprobado', 'Rechazado']"
                label="Estatus"
                filled
                dense
                :disabled="!canManageDocs"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-checkbox
                v-model="formDoc.validacion_dc"
                label="Validación D.C."
                color="success"
                dense
                :disabled="!canManageDocs"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialogDocumento = false" small tile>Cancelar</v-btn>
          <v-btn v-if="canManageDocs" color="green" dark @click="guardarDocumento" small tile>Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="previewDialog" max-width="1100px">
      <v-card>
        <v-card-title class="text-subtitle-1">{{ previewTitle }}</v-card-title>
        <v-card-text style="height: 75vh;">
          <iframe
            v-if="previewUrl"
            :src="previewUrl"
            width="100%"
            height="100%"
            style="border: none;"
          ></iframe>
          <div v-else class="text-body-2 grey--text text--darken-1">
            No se pudo previsualizar el archivo.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="canDownloadDocs" text color="primary" @click="descargarDocumento(previewItem)" :disabled="!previewItem">
            <v-icon left small>mdi-download</v-icon>
            Descargar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="cerrarPreview">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import Alerta from "@/components/alertas/Alerta.vue";
import carga from "@/components/alertas/carga.vue";
import validarErrores from "@/mixins//validarErrores";

export default {
  mixins: [validarErrores],
  components: {
    Alerta,
    carga,
  },
  data: () => ({
    parametros: {
      dialogError: false,
      mensaje: "",
      color: "",
    },
    respuestaAlerta: false,
    cargar: false,
    search: "",
    departamentoFiltro: "",
    dialogDocumento: false,
    previewDialog: false,
    previewUrl: "",
    previewTitle: "",
    previewItem: null,
    archivoDoc: null,
    documentosOficiales: [],
    departamentos: [],
    permisosEdicionIderp: [1, 334, 718],
    puestosSoloVisualizacionSinDescarga: [54, 56, 40, 68, 11],
    formDoc: {
      id: null,
      folio: "",
      nombre_documento: "",
      archivo_nombre: "",
      estatus: "Pendiente",
      validacion_dc: 0,
      comentarios: "",
      id_departamento: "",
    },
    headersDocumentos: [
      { text: "Folio", value: "folio" },
      { text: "Nombre Documento", value: "nombre_documento" },
      { text: "Departamento", value: "departamento" },
      { text: "Documento", value: "archivo_nombre", sortable: false },
      { text: "Comentarios", value: "comentarios" },
      { text: "Acciones", value: "acciones", sortable: false },
    ],
  }),
  computed: {
    ...mapGetters("login", ["getdatosUsuarioERPERP"]),
    canManageDocs() {
      return this.permisosEdicionIderp.includes(Number(this.getdatosUsuarioERPERP.iderp));
    },
    canDownloadDocs() {
      const usuario = this.getdatosUsuarioERPERP || {};
      const idpuesto = Number(usuario.idpuesto || usuario.id_puesto);
      return !this.puestosSoloVisualizacionSinDescarga.includes(idpuesto);
    },
    totalProcesos() {
      return this.documentosOficiales.length;
    },
    kpiProcesosPorDepartamento() {
      const agrupados = this.documentosOficiales.reduce((acc, item) => {
        const nombreDepto =
          item.departamento ||
          this.getNombreDepartamento(item.id_departamento) ||
          "Sin departamento";
        acc[nombreDepto] = (acc[nombreDepto] || 0) + 1;
        return acc;
      }, {});

      return Object.keys(agrupados)
        .map((departamento) => ({
          departamento,
          total: agrupados[departamento],
        }))
        .sort((a, b) => b.total - a.total);
    },
    documentosFiltrados() {
      return this.documentosOficiales;
    },
  },
  watch: {
    departamentoFiltro() {
      this.initializeDocumentos();
    },
  },
  async created() {
    await this.initializeDocumentos();
    await this.getDepartamentos();
  },
  methods: {
    getDocumentoUrl(item) {
      if (!item || !item.archivo_nombre) return "";
      const archivo = encodeURIComponent(item.archivo_nombre);
      const apiBase = (this.$http && this.$http.defaults && this.$http.defaults.baseURL)
        ? this.$http.defaults.baseURL.replace(/\/$/, "")
        : "";
      return apiBase + "/documentos-oficiales/" + archivo;
    },
    getNombreDepartamento(idDepartamento) {
      const dep = this.departamentos.find((item) => Number(item.id) === Number(idDepartamento));
      return dep ? dep.departamento : "";
    },
    initializeDocumentos() {
      this.cargar = true;
      const endpoint = this.departamentoFiltro
        ? "get.documentos.oficiales.por.departamento"
        : "get.todos.los.documentos.oficiales";
      const config = this.departamentoFiltro
        ? { params: { id_departamento: this.departamentoFiltro } }
        : {};

      this.$http
        .get(endpoint, config)
        .then((response) => {
          this.documentosOficiales = response.data;
        })
        .catch((error) => {
          const mensaje =
            (error && error.response && error.response.data && error.response.data.message) ||
            "Error al obtener documentos oficiales";
          this.validarError(mensaje);
        })
        .finally(() => {
          this.cargar = false;
        });
    },
    getDepartamentos() {
      this.cargar = true;
      this.departamentos = [];
      this.$http
        .get("get.todos.los.departamentos.documentos.oficiales")
        .then((response) => {
          this.departamentos = response.data;
        })
        .catch((error) => {
          const mensaje =
            (error && error.response && error.response.data && error.response.data.message) ||
            "Error al obtener departamentos";
          this.validarError(mensaje);
        })
        .finally(() => {
          this.cargar = false;
        });
    },
    crearDocumento() {
      if (!this.canManageDocs) return;
      this.formDoc = {
        id: null,
        folio: "",
        nombre_documento: "",
        archivo_nombre: "",
        estatus: "Pendiente",
        validacion_dc: 0,
        comentarios: "",
        id_departamento: "",
      };
      this.archivoDoc = null;
      this.dialogDocumento = true;
    },
    abrirDialogDocumento(item) {
      if (!this.canManageDocs) return;
      this.formDoc = { ...item };
      this.archivoDoc = null;
      this.dialogDocumento = true;
    },
    guardarDocumento() {
      if (!this.canManageDocs) return;
      if (!this.formDoc.nombre_documento || !this.formDoc.id_departamento) {
        this.$swal({
          icon: "warning",
          title: "Campos incompletos",
          text: "Nombre y Departamento son obligatorios.",
        });
        return;
      }

      if (!this.formDoc.id && !this.archivoDoc) {
        this.$swal({
          icon: "warning",
          title: "Archivo faltante",
          text: "Es obligatorio seleccionar un archivo (PDF o DOC) para subir el documento.",
        });
        return;
      }

      this.cargar = true;
      const formData = new FormData();
      Object.keys(this.formDoc).forEach((key) => {
        if (this.formDoc[key] !== null && this.formDoc[key] !== undefined) {
          formData.append(key, this.formDoc[key]);
        }
      });

      if (this.archivoDoc) {
        formData.append("archivo", this.archivoDoc);
      }

      formData.append("id_usuario_subio", this.getdatosUsuarioERPERP.id_usuario);

      this.$http
        .post("crear.documento.oficial", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.data.success) {
            this.validarSuccess("Documento oficial guardado correctamente");
            this.initializeDocumentos();
            this.dialogDocumento = false;
          }
        })
        .catch((error) => {
          const mensaje =
            (error && error.response && error.response.data && error.response.data.message) ||
            "Error al guardar documento oficial";
          this.validarError(mensaje);
        })
        .finally(() => {
          this.cargar = false;
        });
    },
    eliminarDocumento(item) {
      if (!this.canManageDocs) return;
      this.$swal({
        title: "¿Eliminar este documento?",
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.cargar = true;
          this.$http
            .delete("eliminar.documento.oficial", { data: { id: item.id } })
            .then(() => {
              this.validarSuccess("Documento oficial eliminado");
              this.initializeDocumentos();
            })
            .catch((error) => {
              const mensaje =
                (error && error.response && error.response.data && error.response.data.message) ||
                "Error al eliminar documento";
              this.validarError(mensaje);
            })
            .finally(() => {
              this.cargar = false;
            });
        }
      });
    },
    previsualizarDocumento(item) {
      if (!item || !item.archivo_nombre) return;
      const url = this.getDocumentoUrl(item);
      if (!url) {
        this.validarError("No se pudo previsualizar el archivo.");
        return;
      }

      this.previewUrl = this.canDownloadDocs ? url : this.getPreviewOnlyUrl(url);
      this.previewTitle = item.nombre_documento || item.archivo_nombre;
      this.previewItem = item;
      this.previewDialog = true;
    },
    cerrarPreview() {
      this.previewDialog = false;
      this.previewUrl = "";
      this.previewTitle = "";
      this.previewItem = null;
    },
    descargarDocumento(item) {
      if (!this.canDownloadDocs) {
        this.validarError("Este puesto solo tiene permiso de visualización.");
        return;
      }
      if (!item.archivo_nombre) return;
      const url = this.getDocumentoUrl(item);
      if (!url) {
        this.validarError("No se pudo descargar el archivo.");
        return;
      }

      const extension = item.archivo_nombre.split(".").pop();
      let nombreDescarga = item.nombre_documento || "documento_oficial";
      if (!nombreDescarga.toLowerCase().endsWith("." + extension.toLowerCase())) {
        nombreDescarga += "." + extension;
      }

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nombreDescarga);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getPreviewOnlyUrl(url) {
      const separador = url.includes("#") ? "&" : "#";
      return `${url}${separador}toolbar=0&navpanes=0`;
    },
  },
};
</script>

<style scoped>
.documentos-oficiales-view {
  background: #f6f8fb;
}

.card-minimal {
  border-radius: 14px;
}

.kpi-card {
  border-radius: 14px;
  padding: 16px 18px;
  background: #ffffff;
  border: 1px solid #e9edf4;
}

.kpi-card--principal {
  background: linear-gradient(135deg, #0d47a1, #1565c0);
  color: #ffffff;
  border: none;
}

.kpi-title {
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.2px;
}

.kpi-value {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.1;
  margin-top: 4px;
}

.kpi-caption {
  font-size: 0.75rem;
  opacity: 0.9;
}

.kpi-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 10px;
}

.kpi-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 20px;
  background: #f3f6fb;
}

.kpi-item-label {
  font-size: 0.75rem;
  color: #374151;
}

.kpi-empty {
  font-size: 0.78rem;
  color: #8b95a5;
}

.minimal-input :deep(.v-input__slot) {
  min-height: 36px !important;
}

.table-minimal :deep(th) {
  font-size: 0.75rem;
  color: #667085;
}
</style>
